// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const Flag: React.FC<SvgProps> = (props) => (
  <Svg {...props} width="22.935" height="28.708" viewBox="0 0 22.935 28.708">
    <g
      id="グループ_1294"
      data-name="グループ 1294"
      transform="translate(-623 -94.791)"
    >
      <circle
        id="楕円形_105"
        data-name="楕円形 105"
        cx="2"
        cy="2"
        r="2"
        transform="translate(623 119.5)"
        fill="currentColor"
      />
      <g
        id="グループ_1280"
        data-name="グループ 1280"
        transform="translate(196.5 -220.707)"
      >
        <line
          id="線_106"
          data-name="線 106"
          y2="23.708"
          transform="translate(428.699 316.498)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="多角形_17"
          data-name="多角形 17"
          d="M6.436,2.676a1,1,0,0,1,1.886,0L14.289,19.6a1,1,0,0,1-.943,1.332H1.413A1,1,0,0,1,.47,19.6Z"
          transform="translate(449.435 318) rotate(90)"
          fill="currentColor"
        />
      </g>
    </g>
  </Svg>
);

Flag.displayName = 'Flag';

export default Flag;
